import { render, staticRenderFns } from "./FormCoordinates.vue?vue&type=template&id=8fb85488&scoped=true&lang=pug&"
import script from "./FormCoordinates.vue?vue&type=script&lang=js&"
export * from "./FormCoordinates.vue?vue&type=script&lang=js&"
import style0 from "./FormCoordinates.vue?vue&type=style&index=0&id=8fb85488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb85488",
  null
  
)

export default component.exports